import React from 'react';
import { convertLine } from './Convert';
/**
 * モーダルのbodyを編集
 *
 * @param body モーダルのbodyメッセージ
 */
export var editModalBody = function (body) {
    //改行\nが文字列に存在する場合、エスケープを外して表示する。
    var bodyMessage = convertLine(body);
    return bodyMessage === null ? ('') : (React.createElement("div", null,
        React.createElement("p", { className: "paragraph" }, bodyMessage)));
};
